export default "__VITE_ASSET__ByQNdkkf__"